/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-03-18 14:12:50
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-05-17 18:19:26
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\api\ManagementPlan.js
 */
//管理方案模型

//引入接口文档
import req from '@/utils/req.js'


//管理方案模型列表数据
export function api_managelist(params) {
    return req.get("/admin/scheme/page",params);
}

//管理方案模型添加方案
export function api_postscheme(params) {
    return req.post("/admin/scheme",params);
}

//管理方案模型   方案查询
export function api_getschemeinfo(id) {
    return req.get(`/admin/scheme/${id}`);
}


//管理方案模型   方案编辑
export function api_putschemeinfo(params) {
    return req.put("/admin/scheme/",params);
}

//管理方案模型   方案配置 药品查询
export function api_getdrug(params) {
    return req.get("/admin/drug/",params);
}


//管理方案模型   方案配置 培训教程查询
export function api_get_train_course(params) {
    return req.get("/admin/train-course",params);
}


//管理方案模型   方案配置 培训教程目录表查询
export function api_get_train_chapter(params) {
    return req.get("/admin/train-chapter/",params);
}


//管理方案模型   方案配置 培训教程目录表查询
export function api_get_patient_wholeScheme(id) {
    return req.get(`/admin/patient-scheme/whole-course/${id}`);
}



//个案管理   方案配置 更新接口
export function api_put_patient_scheme(params) {
    return req.put("/admin/patient-scheme",params);
}


//管理方案模型，查询问卷接口
export function api_get_oss_surveys(params) {
    return req.get("/admin/exam-paper",params);
}


//管理方案模型，疾病类型
export function api_get_disease_type(params) {
    return req.get("/admin/disease-type",params);
}

export function api_get_disease_type1(params) {
    return req.get("/admin/disease-type/findDiseaseTypeByCondition",params);
}

//获取疾病类型/主要诊断
export function api_disease_type(params) {
    return req.get("/admin/disease-type",params);
}


//删除编链接口
export function api_delete_scheme(id) {
    return req.delete(`/admin/scheme/${id}`);
}

//获取疾病类型/主要诊断
export function api_column_list(params) {
    return req.post("/admin/column/list",params);
}
//获取运动分类
export function api_standard_list(params) {
    return req.post("/admin/standard-category/list",params);
}
//根据运动分类获取项目
export function api_movement_info_list(params) {
    return req.post("/admin/movement-info/list",params);
}

//识别文字
export function recognizeContent(params) {
    return req.post("/admin/mission/recognizeContent",params);
}

//获取最新语音
export function getVoiceReport(params) {
    return req.post("/admin/mission/getVoiceReport",params);
}

//获取最新语音
export function taskId(params) {
    return req.get(`/dsicm-contact-platform//feign/ali-nls-task/taskId/${params.taskId}`,params);
}

//获取最新语音
// export function taskId(params) {
//     return req.get(`/dsicm-contact-platform/feign/ali-nls-task/taskId/${params.taskId}`,params);
// }